// extracted by mini-css-extract-plugin
export var shake = "_w-0";